<template>
  <iframe v-if="course.hasWebVersion == 1 && course.is_vr == 0" id="vtsContent" :src="this.path"
          class="h-100 w-100"
          allowusermedia
          allowfullscreen>
  </iframe>
  <div v-else class="d-flex h-100 align-items-center justify-content-center">
    <div class="activity-alert d-flex flex-column"
         :class="{'clear': !organization.darkMode}">
      <span class="h6 font-weight-bold">{{$t('app.activity.not.compatible.1')}}</span>
      <span class="h6">{{$t('app.activity.not.compatible.2')}}</span>
      <span class="h6">{{$t('app.activity.not.compatible.3')}}</span>
      <a class="btn btn-outline-primary font-weight-bold my-3" :href="getDownloadPlayerLink()">
        {{$t('app.activity.not.compatible.4')}}</a>
      <a
        class="btn btn-primary font-weight-bold"
        target="_blank"
        :href="`com-sf-vtsplayer://open-idp?orgid=${organization.id}&session=${currentSession.id}&ppi=${course.performProjectId}`">{{$t('app.activity.goto.vtsplayer')}}
      </a>
    </div>
  </div>

</template>
<script>

import { mapGetters } from 'vuex';
import {
  SET_COURSE,
  FETCH_COURSES,
} from '@/store/actions.type';
import store from '@/store';
import { getToken } from '@/common/jwt.service';
import HelperMixin from '@/mixins/helperMixin';

export default {
  name: 'VTSViewer',
  mixins: [HelperMixin],
  components: {
  },
  computed: {
    path() {
      return `${process.env.VUE_APP_API_URL}/api/front/v1/player/${this.course.organization_id}/${this.currentSession.attendee}/${this.course.glue}/vts/player?token=${getToken()}&portal=${this.portal}`;
    },
    ...mapGetters(['course', 'organization', 'currentSession', 'portal']),
  },
  mounted() {
    this.terminated = false;
    window.addEventListener('message', this.receiveMessage);
  },
  watch: {
    $route() {
      this.terminated = false;
      this.locked = false;
    },
  },
  beforeRouteUpdate() {
    this.terminated = false;
    this.locked = false;
  },
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  },
  data() {
    return {
      terminated: false,
      locked: false,
    };
  },
  props: {
  },
  methods: {
    postData() {
      if (this.terminated) return new Promise((resolve) => setTimeout(resolve, 10));
      document.getElementById('vtsContent').contentWindow.postMessage('vtsClose', process.env.VUE_APP_API_URL);
      return new Promise((resolve) => setTimeout(resolve, 1000));
    },
    getDownloadPlayerLink() {
      const { userAgent, platform } = window.navigator;
      const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
      const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
      const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
      let link = '';

      if (macosPlatforms.indexOf(platform) !== -1) {
        link = 'https://www.seriousfactory.com/vtsmanager/web/get/VTSPLAYER.mac';
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        link = 'https://apps.apple.com/fr/app/vts-player/id1196791564';
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        link = 'https://www.seriousfactory.com/vtsmanager/web/get/VTSPLAYER.win';
      } else if (/Android/.test(userAgent)) {
        link = 'https://play.google.com/store/apps/details?id=com.seriousfactory.vtsplayer&hl=fr&gl=US';
      } else if (!link && /Linux/.test(platform)) {
        link = 'https://www.seriousfactory.com/vtsmanager/web/get/VTSPLAYER.win';
      }
      return link;
    },
    receiveMessage(e) {
      if (e.data === 'vtsCommited') {
        store.dispatch(FETCH_COURSES).then(() => {
          store.dispatch(SET_COURSE, this.course.id).then(() => {
            if (this.course.completed === '1') {
              this.terminated = true;
              this.locked = false;
            }
            this.$Progress.finish();
          });
        });
      } else if (e.data === 'vtsStarted' && this.course.completed !== '1') {
        this.locked = true;
      } else if (e.data === 'vtsTokenError') {
        this.$dialog.alert(this.$t('app.activity.token.error'), {
          backdropClose: false,
          okText: this.$t('app.activity.token.ok'),
        }).then(() => window.location.reload());
      } else if (e.data === 'vtsCommitError') {
        this.$dialog.alert(this.$t('app.activity.commit.error'), {
          backdropClose: true,
          okText: this.$t('app.activity.commit.ok'),
        });
      }
    },
  },
};
</script>
